import * as types from '../const/action.types';
import { get, put, post } from '../api/_basic';

export function allForecast(filtro) {
    return async (dispatch) => {
        dispatch(forecastHasErrored(false, ''));
        dispatch(forecastIsLoading(true));
        let url = undefined;
        if (filtro && (filtro.hasta || filtro.local)) {
            let parameter = filtro.hasta
                ? `hasta=${filtro.hasta}` + (filtro.desde || filtro.local ? '&' : '')
                : '';
            parameter = `${parameter} ${
                filtro.desde ? `desde=${filtro.desde}` + (filtro.local ? '&' : '') : ''
            }`;
            parameter = `${parameter} ${filtro.local ? `idLocal=${filtro.local}` : ''}`;
            url = `${process.env.REACT_APP_API_FORECAST}?${parameter}`;
        } else {
            url = `${process.env.REACT_APP_API_FORECAST}`;
        }
        return get(url)
            .then((response) => {
                dispatch(forecastIsLoading(false));
                if (response.error !== undefined) {
                    throw Error(response);
                }
                return response;
            })
            .then((items) => {
                dispatch(forecastHasErrored(false, ''));
                dispatch(loadForecastListSuccess(items));
            })
            .catch((error) => {
                dispatch(forecastIsLoading(false));
                dispatch(forecastHasErrored(error.type ? error.type : true, error.message));
            });
    };
}

export function add(forecast) {
    return async (dispatch) => {
        dispatch(forecastIsSaving(true));
        return post(`${process.env.REACT_APP_API_FORECAST}`, forecast)
            .then((response) => {
                dispatch(forecastIsSaving(false));
                if (response.error !== undefined) {
                    throw Error(response);
                }
                return response;
            })
            .then((items) => {
                return true;
            })
            .catch((error) => {
                console.log(error);
                throw error;
            });
    };
}

export function edit(forecast) {
    return async (dispatch) => {
        dispatch(forecastIsSaving(true));
        return put(`${process.env.REACT_APP_API_FORECAST}/${forecast.id}/aprobar`, forecast)
            .then((response) => {
                dispatch(forecastIsSaving(false));
                if (response.error !== undefined) {
                    throw Error(response);
                }
                return response.data;
            })
            .then((items) => {
                return true;
            })
            .catch((error) => {
                console.log(error);
                throw error;
            });
    };
}

export function load(forecast) {
    return async function(dispatch) {
        dispatch(loadForecastItemSuccess({}));
        return get(`${process.env.REACT_APP_API_FORECAST}/${forecast}`)
            .then((response) => {
                dispatch(forecastIsLoading(false));
                return response;
            })
            .then((item) => {
                if (item.error !== undefined) {
                    dispatch(forecastHasErrored(item.type ? item.type : true, item.error));
                } else {
                    dispatch(forecastHasErrored(false, ''));
                    dispatch(loadForecastItemSuccess(item));
                }
            })
            .catch((error) => {
                dispatch(forecastIsLoading(false));
                dispatch(forecastHasErrored(error.type ? error.type : true, error.message));
            });
    };
}

export function postForecast(local) {
    return async (dispatch) => {
        dispatch(forecastIsSaving(true));
        return post(`${process.env.REACT_APP_API_LOCAL}/${local}/previsionventa`, {})
            .then((response) => {
                dispatch(forecastIsSaving(false));
                if (response.error !== undefined) {
                    throw Error(response);
                }
                return response;
            })
            .catch((error) => {
                console.error(error);
                throw error;
            });
    };
}

export function loadForecastItemSuccess(data) {
    return {
        type: types.LOAD_FORECAST_SUCCESS,
        data,
    };
}

export function loadForecastListSuccess(data) {
    return {
        type: types.FORECASTS_SUCCESS,
        data,
    };
}

export function forecastHasErrored(bool, message) {
    return {
        type: types.FORECASTS_HAS_ERROR,
        hasErrored: bool,
        error: message,
    };
}

export function forecastIsLoading(bool) {
    return {
        type: types.FORECASTS_IS_LOADING,
        isLoading: bool,
    };
}

export function forecastIsSaving(bool) {
    return {
        type: types.FORECASTS_IS_SAVING,
        isLoading: bool,
    };
}



// WEBPACK FOOTER //
// ./src/actions/forecast.actions.js